function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import Item from './Item';
import { Container } from './elements';
/**
 * List component displays a list of items through a `data` prop
 * You can format the data to stylise it or render the item in one line.
 *
 * See README.md and its stories from Storybook for documentation and examples
 *
 * @return {jsx}
 */

var List = forwardRef(function (_ref, ref) {
  var className = _ref.className,
      currency = _ref.currency,
      data = _ref.data,
      locale = _ref.locale;
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    ref: ref
  }, data.map(function (_ref2, index) {
    var amount = _ref2.amount,
        evolution = _ref2.evolution,
        label = _ref2.label;
    return /*#__PURE__*/React.createElement(Item, _extends({
      key: index,
      amount: amount,
      currency: currency
    }, typeof evolution !== 'undefined' ? {
      evolution: evolution
    } : {}, {
      locale: locale,
      "data-testid": "list-item"
    }), label);
  }));
});
var arrayOf = Proptypes.arrayOf,
    node = Proptypes.node,
    number = Proptypes.number,
    oneOfType = Proptypes.oneOfType,
    shape = Proptypes.shape,
    string = Proptypes.string;
List.propTypes = {
  /** Needed by styled-components for custom style */
  className: string,

  /** Currency for amount values */
  currency: string,

  /**
   * Data to display in the List component
   */
  data: arrayOf(shape({
    amount: node,
    evolution: number,
    label: oneOfType([node, string])
  })).isRequired,

  /**
   * locale code used to properly format numbers
   */
  locale: string
};
List.defaultProps = {
  className: undefined,
  currency: null,
  locale: 'en'
};
List.displayName = 'List';
export default List;